import React, { Component, PureComponent } from 'react'
import { Map, List, fromJS } from 'immutable'
import { push } from 'react-router-redux'
import { Icon } from 'semantic-ui-react'
import { fetchUsers } from '~/user/actions'
import { connect } from 'react-redux'
import DataTable from '../datatable'
import Edit from './edit'
import moment from 'moment'

const resultTitles = {
  buy: 'Osti vuositilauksen',
  call_later: 'Soita myöhemmin',
  no_buy: 'Ei ostanut',
}

const resultColors = {
  buy: 'green',
  call_later: 'blue',
  no_buy: 'red',
}

const opcos = {
  FI: 'FI',
  US: 'US',
  SE: 'SE',
  G: 'G',
}

class OrganizationRoot extends PureComponent {
  componentDidMount = () => {
    let { usersLoading, fetchUsers } = this.props

    if (usersLoading) fetchUsers()
  }

  render() {
    let { users } = this.props

    users = users.reduce((mapped, user) => {
      mapped[user.get('id')] = user.get('name')
      return mapped
    }, {})

    const columns = [
      {
        name: 'name',
        label: 'Nimi',
        sortable: true,
        id: true,
        defaultSort: true,
      },
      {
        name: 'businessid',
        label: 'Y-tunnus',
        sortable: true,
        id: true,
      },
      {
        name: 'user',
        label: 'Vastuuhenkilö',
        render: i => {
          let userId = i.getIn(['data', 'userOwner'], false)
          return users[userId] || false
        },
        export: i => {
          let userId = i.getIn(['data', 'userOwner'], false)
          return users[userId] || false
        },
      },
      {
        name: 'operating_company_id',
        label: 'Opco',
      },
      {
        name: 'created_at',
        label: 'Luotu',
        date: 'DD.MM.YYYY - HH:mm',
        width: 200,
        sortable: true,
      },
      {
        name: 'updated_at',
        label: 'Päivitetty',
        date: 'DD.MM.YYYY - HH:mm',
        width: 200,
        sortable: true,
      },
    ]

    const filterFields = [
      {
        type: 'group',
        placeholder: 'Henkilöt',
        icon: 'user',
        fields: [
          {
            name: 'data.userOwner',
            type: 'checkboxes',
            label: 'Vastuuhenkilö',
            options: Object.keys(users).map(userId => ({ value: userId, label: users[userId] })),
          },
        ],
      },
      {
        type: 'group',
        placeholder: 'OPCO',
        icon: 'building',
        fields: [
          {
            name: 'operating_company_id',
            type: 'checkboxes',
            label: 'OPCO',
            options: Object.keys(opcos).map(key => ({ value: key, label: opcos[key] })),
          },
        ],
      },
    ]

    return (
      <DataTable
        id="organizations"
        entity="organization"
        crud
        title="Organisaatiot"
        texts={{ createButton: 'Lisää organisaatio' }}
        filters
        filterFields={filterFields}
        editComponent={Edit}
        editWide
        columns={columns}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    users: state.users,
    usersLoading: state.usersLoading,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchPlans: () => dispatch(fetchPlans()),
    fetchUsers: () => dispatch(fetchUsers()),
    changeRoute: path => dispatch(push(path)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationRoot)
